import React from "react";
import { observer } from "mobx-react";
import { TenantStorageUsageViewStore } from "../../store";
import { TenantStorageUsageViewForm } from "./TenantStorageUsageViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type TenantStorageUsageViewProps = {
  tenantStorageUsageViewStore: TenantStorageUsageViewStore;
};

export const TenantStorageUsageView: React.FC<TenantStorageUsageViewProps> =
  observer(({ tenantStorageUsageViewStore }) => {
    return (
      <div>
        <TenantStorageUsageViewForm
          operationOptions={tenantStorageUsageViewStore.getOperationOptions()}
          operation={tenantStorageUsageViewStore.operationValue}
          bytes={tenantStorageUsageViewStore.bytesValue}
          documentName={tenantStorageUsageViewStore.documentNameValue}
          documentId={tenantStorageUsageViewStore.documentIdValue}
          fileType={tenantStorageUsageViewStore.fileTypeValue}
          timestamp={tenantStorageUsageViewStore.timestampValue}
          balanceAfter={tenantStorageUsageViewStore.balanceAfterValue}
          onPrint={(handlePrint: () => void) =>
            tenantStorageUsageViewStore.printTenantStorageUsage(handlePrint)
          }
          onCancel={() =>
            tenantStorageUsageViewStore.cancelTenantStorageUsage()
          }
          onEdit={
            tenantStorageUsageViewStore.isEditEnabled
              ? () => tenantStorageUsageViewStore.editTenantStorageUsage()
              : undefined
          }
        />
        <ErrorDialog
          open={tenantStorageUsageViewStore.errorDialogOpened}
          title={tenantStorageUsageViewStore.errorTitle}
          description={tenantStorageUsageViewStore.errorDescription}
          onClose={() => tenantStorageUsageViewStore.closeErrorDialog()}
        />
      </div>
    );
  });
